import React, { useEffect, useState } from "react";
import classes from "./WeatherPage.module.css";
import Grid from "@mui/material/Grid";
import BackButton from "../../common/BackButton";
import WeatherCard from "./WeatherCard/WeatherCard";
import getWeatherInfo from "../../../api/getWeatherInfo";
import Loader from "../../common/Loader/Loader";
import { Typography } from "@mui/material";

//IN CASE OF API ERROR - FOR PRESENTATION PURPOSES
const artificialData = [
  {
    temp: 1.2,
    weather: "Clouds",
  },
  {
    temp: 1.4,
    weather: "Rain",
  },
  {
    temp: 0.2,
    weather: "Drizzle",
  },
  {
    temp: -1,
    weather: "Snow",
  },
  {
    temp: 0.8,
    weather: "Thunderstorm",
  },
];

function WeatherPage() {
  let [data, setData] = useState([]);
  useEffect(() => {
    getWeatherInfo().then((res) => {
      setData(res);
    });
  }, []);

  if (data === undefined) {
    console.log("USING ARTIF DATA FOR WEATHER");
    //JUST IN CASE OF ERROR
    data = artificialData;
  }

  const time = new Date();

  if (data.length === 0) {
    return (
      <>
        <Typography
          component="div"
          variant="h1"
          display="flex"
          justifyContent="center"
          sx={{
            padding: 20,
          }}
        >
          Košice
        </Typography>
        <BackButton />
        <Grid
          container
          direction={"row"}
          justifyContent={"space-evenly"}
          alignItems={"center"}
          className={classes.grid}
        >
          <Grid item>
            <Loader />;
          </Grid>
        </Grid>
      </>
    );
  }
  return (
    <>
      <Grid className={classes.grid}>
        <Typography
          component="div"
          variant="h1"
          display="flex"
          justifyContent="center"
          sx={{
            pt: 20,
            pb: 2,
          }}
        >
          Košice
        </Typography>
        <Typography
          component="div"
          variant="h2"
          display="flex"
          justifyContent="center"
          sx={{
            pb: 5,
          }}
        >
          {time.getHours() + ":" + time.getMinutes()}
        </Typography>
        <BackButton />
        <Grid
          className={classes.gridWeather}
          container
          direction={"row"}
          justifyContent={"space-evenly"}
          spacing={3}
        >
          {data.map((day, index) => {
            return (
              <Grid item className={classes.gridItem} key={index + day.temp}>
                <WeatherCard
                  temperature={day.temp}
                  text={day.weather}
                  dayInArray={index}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
}
export default WeatherPage;
